'use strict'

export default (mockAxios) => {
  // 取得
  mockAxios.onGet(`/mbcsettings`).reply(200, {
    'success': true,
    'data': {
      'sp_con_order': [
        1,
        2,
        3,
        4,
        5
      ],
      'sp_con_row': 5
    }
  })

  // 更新
  mockAxios.onPut(`/mbcsettings`).reply(201, {
    'success': true,
    'data': []
  })
}



// WEBPACK FOOTER //
// ./src/repositories/mock/mobileSettingRepositoryMock.js